import React, { useState, useEffect } from 'react';
import '../styles/Requests.css';
import { getNetwork, sendRequest, removeContact } from '../api/graph';

// My confirmed direct links + a form to send a new trust request (Work or Personal).
// The requester never learns the outcome, so the confirmation here is deliberately neutral.
function MyNetwork() {
  const [network, setNetwork] = useState([]);
  const [loading, setLoading] = useState(true);
  const [email, setEmail] = useState('');
  const [type, setType] = useState('work');
  const [sending, setSending] = useState(false);
  const [notice, setNotice] = useState('');
  const [error, setError] = useState('');

  const load = async () => {
    try {
      const data = await getNetwork();
      setNetwork(data.network || []);
    } catch (err) {
      setError(err.message || 'Could not load your network');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, []);

  const remove = async (contact) => {
    const label = contact.name || contact.email;
    // eslint-disable-next-line no-restricted-globals, no-alert
    if (!window.confirm(`Remove and block ${label}? They won't be told. This also stops them re-requesting you.`)) return;
    setError('');
    try {
      await removeContact(contact.id);
      setNetwork((prev) => prev.filter((p) => p.id !== contact.id));
    } catch (err) {
      setError(err.message || 'Could not remove');
    }
  };

  const submit = async (e) => {
    e.preventDefault();
    setNotice('');
    setError('');
    setSending(true);
    try {
      const res = await sendRequest(email.trim(), type);
      if (res.alreadyConnected) {
        setNotice("You're already connected.");
      } else if (res.connected) {
        setNotice('You are now connected.');
        load();
      } else if (res.member === false) {
        setNotice('They are not on ConnectMi yet — share your personal invite link.');
      } else {
        setNotice('Request sent. You will only ever know if they say yes.');
      }
      setEmail('');
    } catch (err) {
      setError(err.message || 'Could not send request');
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="requests-container">
      <div className="requests-head">
        <h3>Add a trusted link</h3>
        <p className="requests-sub">Send to people you truly trust. They answer privately.</p>
      </div>

      <form className="send-form" onSubmit={submit}>
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="their@email.com"
          required
          disabled={sending}
        />
        <div className="type-toggle">
          <button
            type="button"
            className={type === 'work' ? 'tt active-work' : 'tt'}
            onClick={() => setType('work')}
          >
            Work
          </button>
          <button
            type="button"
            className={type === 'personal' ? 'tt active-personal' : 'tt'}
            onClick={() => setType('personal')}
          >
            Personal
          </button>
        </div>
        <button type="submit" className="btn-yes" disabled={sending}>
          {sending ? 'Sending…' : 'Send request'}
        </button>
      </form>

      {notice && <div className="send-notice">{notice}</div>}
      {error && <div className="error-message">{error}</div>}

      <div className="requests-head" style={{ marginTop: 28 }}>
        <h3>Your network</h3>
        <p className="requests-sub">Confirmed links only. You see your direct connections — nobody else's.</p>
      </div>

      {loading ? (
        <div className="requests-empty">Loading…</div>
      ) : network.length === 0 ? (
        <div className="requests-empty">No confirmed links yet. Send a request above to start.</div>
      ) : (
        <div className="network-list">
          {network.map((p) => (
            <div key={p.id} className="network-row">
              <div className={`req-avatar ${p.relationshipType === 'personal' ? 'personal' : 'work'}`}>
                {(p.name || p.email || '?')[0].toUpperCase()}
              </div>
              <div className="network-name">
                <div>{p.name || p.email}</div>
                <div className="req-meta">
                  {[p.employer, p.industry].filter(Boolean).join(' · ') || p.email}
                </div>
              </div>
              <span className={p.relationshipType === 'personal' ? 'tag-personal' : 'tag-work'}>
                {p.relationshipType === 'personal' ? 'Personal' : 'Work'}
              </span>
              <button type="button" className="btn-remove" title="Remove & block (silent)" onClick={() => remove(p)}>
                Remove
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default MyNetwork;
